export function LoadingState({ message = 'Loading archive…' }: { message?: string }) {
  return (
    <div className="state-panel loading-panel" role="status" aria-live="polite">
      <div className="spinner" aria-hidden />
      <p>{message}</p>
    </div>
  );
}
